import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  input,
  Optional,
  Self,
} from '@angular/core';
import { ReactiveFormsModule, ControlValueAccessor, NgControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-input-field',
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './input-field.component.html',
  styleUrl: './input-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFieldComponent implements ControlValueAccessor {
  public readonly inputType = input<string>('text');
  public readonly label = input.required<string>();
  public readonly controlId = input.required<string>();
  public readonly customMessage = input.required<string>();
  public readonly placeholder = input.required<string>();

  protected readonly isTextArea = computed(() => this.inputType() === 'textarea');

  public value = '';

  private onChange: (value: string) => void = () => {
    return;
  };
  private onTouched: () => void = () => {
    return;
  };

  private readonly cdr = inject(ChangeDetectorRef);

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(obj: string): void {
    this.value = obj;
    this.cdr.markForCheck();
  }
  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public onInput(event: Event):void {
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChange(value);
  }

  public onBlur():void {
    this.onTouched();
  }

  public displayError(): string {
    const control = this.ngControl?.control;
    const value = control?.value.trim();

    if (control?.touched && control?.invalid && value === '') {
      return 'empty';
    } else if (control?.dirty && control?.invalid) {
      return 'invalid';
    }
    return 'valid';
  }
}
